import React from 'react';

const TermsConditionsRO: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptarea Termenilor</h2>
        <p className="mb-4">
          Prin descărcarea, instalarea sau utilizarea aplicației mobile și site-ului web GatherPlay ("Serviciul"), 
          acceptați să fiți obligați de acești Termeni și Condiții ("Termenii"). Dacă nu sunteți de acord cu acești Termeni, nu utilizați Serviciul.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Furnizor de Servicii:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Companie: BIXMO SRL</li>
            <li>Adresă: Chișinău, Moldova</li>
            <li>Email: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Descrierea Serviciului</h2>
        <p className="mb-4">
          GatherPlay este un joc multiplayer unde jucătorii interpretează scenarii bazate pe niveluri de intensitate 
          numerotate în timp ce un jucător încearcă să ghicească cine are ce număr. Serviciul include:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Aplicația mobilă pentru dispozitivele iOS și Android</li>
          <li>Aplicația web accesibilă prin browsere</li>
          <li>Funcționalitatea de joc multiplayer</li>
          <li>Conținutul cardurilor de scenarii</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Cerințe de Vârstă</h2>
        <p>
          GatherPlay este destinat utilizatorilor cu vârsta de 6 ani în sus. Utilizatorii sub 13 ani ar trebui să 
          utilizeze Serviciul sub supravegherea părinților. Prin utilizarea Serviciului, declarați că îndepliniți cerințele de vârstă.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Conduita Utilizatorului</h2>
        <p className="mb-4">Acceptați să utilizați Serviciul responsabil și acceptați să NU:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Utilizați Serviciul în orice scop ilegal sau în încălcarea oricărei legi locale, de stat, naționale sau internaționale</li>
          <li>Hărțuiți, abuzați sau răniti alți jucători</li>
          <li>Încercați să faceți inginerie inversă, să modificați sau să hackerați aplicația</li>
          <li>Utilizați scripturi automate sau boți pentru a interacționa cu Serviciul</li>
          <li>Partajați conținut neadecvat în timpul jocului</li>
          <li>Interferați cu sau să perturbați Serviciul sau serverele</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Drepturile de Proprietate Intelectuală</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.1 Conținutul Nostru</h3>
        <p className="mb-4">Tot conținutul din GatherPlay, incluzând dar fără a se limita la:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Mecanica jocului și regulile</li>
          <li>Cardurile de scenarii și conținutul jocului</li>
          <li>Codul software și algoritmii</li>
          <li>Grafica, logourile și elementele de design</li>
          <li>Textul și materialele scrise</li>
        </ul>
        <p className="mb-4">este deținut de BIXMO SRL și protejat prin drepturi de autor, mărci comerciale și alte legi ale proprietății intelectuale.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.2 Licența Dvs.</h3>
        <p>
          Vă acordăm o licență limitată, neexclusivă, netransferabilă pentru a utiliza Serviciul pentru scopuri 
          personale, necomerciale în conformitate cu acești Termeni.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Funcții Premium și Plăți</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.1 Achiziție în Aplicație</h3>
        <p className="mb-4">
          GatherPlay oferă o actualizare premium disponibilă prin achiziția în aplicație care elimină reclamele. 
          Aceasta este o achiziție unică legată de contul dvs. din magazinul de aplicații.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.2 Rambursări</h3>
        <p className="mb-4">
          Politicile de rambursare sunt guvernate de politicile respectivelor magazine de aplicații (Apple App Store 
          sau Google Play Store). Nu procesăm rambursări direct.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.3 Modificări de Preț</h3>
        <p>
          Îți rezervăm dreptul de a schimba prețul funcțiilor premium în orice moment, deși modificările nu vor 
          afecta achizițiile existente.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Publicitate</h2>
        <p>
          Versiunea gratuită a GatherPlay afișează reclame. Prin utilizarea versiunii gratuite, consimțiți să vizualizați 
          aceste reclame. Reclamele sunt furnizate de rețele terțe și nu suntem responsabili pentru conținutul lor.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Date și Confidențialitate</h2>
        <p>
          Confidențialitatea dvs. este importantă pentru noi. Vă rugăm să revizuiți Politica noastră de Confidențialitate, 
          care explică cum colectăm, utilizăm și protejăm informațiile dvs. Politica de Confidențialitate este încorporată în acești Termeni prin referință.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Disponibilitatea Serviciului</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.1 Disponibilitate</h3>
        <p className="mb-4">
          Ne străduim să menținem Serviciul disponibil 24/7, dar nu garantăm accesul neîntrerupt. Serviciul poate fi 
          temporar indisponibil din cauza:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Întreținerii programate</li>
          <li>Dificultăților tehnice</li>
          <li>Factorilor în afara controlului nostru</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.2 Actualizări</h3>
        <p>
          Putem actualiza Serviciul din când în când pentru a adăuga funcții, pentru a corecta erori sau pentru a 
          îmbunătăți performanța. Unele actualizări pot fi necesare pentru utilizarea continuă a Serviciului.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Limitarea Responsabilității</h2>
        <p className="mb-4">În măsura maximă permisă de legea aplicabilă:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Serviciul este furnizat "așa cum este" fără garanții de orice fel</li>
          <li>Nu suntem responsabili pentru niciun fel de daune indirecte, incidentale, speciale sau consecutive</li>
          <li>Responsabilitatea noastră totală nu va depăși suma pe care ați plătit-o pentru funcțiile premium (dacă este cazul)</li>
          <li>Nu suntem responsabili pentru nicio pierdere de date sau întrerupere a serviciului</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Despăgubire</h2>
        <p>
          Acceptați să despăgubiți și să feriți de răspundere BIXMO SRL de orice revendicări, daune sau cheltuieli 
          rezultate din utilizarea dvs. a Serviciului sau încălcarea acestor Termeni.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Încetarea</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.1 Încetarea de către Dvs.</h3>
        <p className="mb-4">Puteți înceta să utilizați Serviciul în orice moment prin dezinstalarea aplicației.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.2 Încetarea de către Noi</h3>
        <p className="mb-4">
          Putem înceta sau suspenda accesul dvs. la Serviciu în orice moment, cu sau fără motiv, cu sau fără notificare.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.3 Efectul Încetării</h3>
        <p>
          La încetare, dreptul dvs. de a utiliza Serviciul încetează imediat. Prevederile care ar trebui să supraviețuiască 
          încetării (incluzând drepturile de proprietate intelectuală, limitarea responsabilității și despăgubirile) vor continua să se aplice.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Legea Aplicabilă</h2>
        <p>
          Acești Termeni sunt guvernați și interpretați în conformitate cu legile Republicii Moldova, fără a ține 
          seama de prevederile sale privind conflictul de legi.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Soluționarea Disputelor</h2>
        <p>
          Orice dispute care rezultă din acești Termeni sau din utilizarea Serviciului vor fi soluționate prin arbitraj 
          obligatoriu în conformitate cu legile Republicii Moldova, sau în instanțele competente din Chișinău, Moldova.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Modificări ale Termenilor</h2>
        <p className="mb-4">Îți rezervăm dreptul de a modifica acești Termeni în orice moment. Vom notifica utilizatorii despre modificările materiale prin:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Postarea Termenilor actualizați în aplicație</li>
          <li>Actualizarea datei "Ultima Actualizare"</li>
          <li>Furnizarea de notificare în aplicație pentru modificări semnificative</li>
        </ul>
        <p>Utilizarea continuă a Serviciului după modificări constituie acceptarea Termenilor actualizați.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Separabilitate</h2>
        <p>
          Dacă orice prevedere din acești Termeni este considerată neexecutabilă, restul Termenilor va rămâne în 
          vigoare deplină și efect.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Informații de Contact</h2>
        <p className="mb-4">Pentru întrebări despre acești Termeni și Condiții, vă rugăm să ne contactați:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Email: gatherplay.application@gmail.com</li>
          <li>Companie: BIXMO SRL, Chișinău, Moldova</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">18. Acordul Complet</h2>
        <p>
          Acești Termeni, împreună cu Politica noastră de Confidențialitate, constituie acordul complet între dvs. 
          și BIXMO SRL cu privire la utilizarea Serviciului.
        </p>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Prin utilizarea GatherPlay, recunoașteți că ați citit, înțeles și acceptați să fiți obligați de acești 
          Termeni și Condiții.
        </p>
      </div>
    </div>
  );
};

export default TermsConditionsRO;